import { Badge, Table, Text } from '@mantine/core'

// #1133(柱4-5)admin 応募詳細の面談履歴。過去の面談(cancelled / declined / done)を一覧表示する。
// キャンセル理由(cancelReason)は admin の内部メモだが、この画面は admin 専用なので表示してよい
// (Interview#serializable_hash は落とすため、Rails 側で必要な値だけを Hash に組んで渡す)。
const STATUS_COLORS = {
  declined: 'red',
  cancelled: 'gray',
  done: 'green',
}

export default function AdminInterviewHistory({ rows = [] }) {
  if (rows.length === 0) {
    return (
      <Text fz="sm" c="dimmed">
        過去の面談はありません。
      </Text>
    )
  }

  return (
    <Table withRowBorders withTableBorder verticalSpacing="xs" fz="sm">
      <Table.Thead>
        <Table.Tr>
          <Table.Th>状態</Table.Th>
          <Table.Th>日時</Table.Th>
          <Table.Th>面談形式</Table.Th>
          <Table.Th>キャンセル理由(内部メモ)</Table.Th>
          <Table.Th>起票日時</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {rows.map((row) => (
          <Table.Tr key={row.id}>
            <Table.Td>
              <Badge color={STATUS_COLORS[row.status] || 'gray'} variant="light" radius="sm">
                {row.statusLabel}
              </Badge>
            </Table.Td>
            <Table.Td>
              {row.scheduledAt || (
                <Text c="dimmed" span>
                  -
                </Text>
              )}
            </Table.Td>
            <Table.Td>{row.formatLabel}</Table.Td>
            <Table.Td>
              {row.cancelReason || (
                <Text c="dimmed" span>
                  -
                </Text>
              )}
            </Table.Td>
            <Table.Td>{row.createdAt}</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  )
}
